export function getMembersByRoomId(roomId) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/GetMembersByRoomId',
        method: 'get',
        params: { roomId: roomId }
    });
}

/*合同详情*/
export function getRoomOwnerById(id) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/GetRoomOwnerById',
        method: 'get',
        params: { id: id }
    });
}

/*更新*/
export function updateRoomOwner(data = {}) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/UpdateRoomOwner',
        method: 'put',
        data: data
    });
}

/*上传产证*/
export function savePropertyCertificate(data = {}) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/SavePropertyCertificate',
        method: 'post',
        data: data
    });
}
/*上传合同*/
export function saveRoomContract(data = {}) {
    return abp.ajax({
        url: '/api/services/app/NewOwner/SaveRoomContract',
        method: 'post',
        data: data
    });
}
